import * as React from "react";
import {
    LoginNotification,
    ProductView,
    RevokeItemRequest,
    RevokeItemResponse, RevokeResult
} from "../../../../generated/protocol";
import {RouterView} from "../RouterView";
import {Form} from "../../form/Form";
import {FormGroup} from "../../form/FormGroup";
import {kernel} from "../../../ioc/IOCHelper";
import {FormSubmitError} from "../../form/FormFeedback";
import {ItemService, ITEM_SERVICE_NAME} from "../../../service/admin/ItemService";
import {SelectInput} from "../../form/SelectInput";
import {NotificationService} from "../../../service/admin/NotificationService";
import {Symbols} from "../../../ioc/Symbols";
import {DeleteButtonModal} from "../../util/DeleteButtonModal";

interface State {
    request?: RevokeItemRequest;
    response?: RevokeItemResponse;
    activeNotifications?: LoginNotification[];
    validationMap?: any;
    notification?: LoginNotification;
}

export class ItemRefundView extends RouterView<{ params: { id: string } }, State> {

    itemService: ItemService;
    notificationService: NotificationService;

    constructor() {
        super();
        this.state = {validationMap: {}, request: {}};
        this.itemService = kernel.get<ItemService>(ITEM_SERVICE_NAME);
        this.notificationService = kernel.get<NotificationService>(Symbols.NotificationService);
    }

    loadContent(): Promise<void> {
        return this.notificationService.getActiveNotifications().then(r => {
            this.setState( {activeNotifications: r})
        });
    }

    onSubmit(): Promise<void> {
        const request = { ...this.state.request };
        request.itemId = this.props.params.id;
        return this.itemService.revokeItem(request).then(result => {
            this.setState({response: result});
        });
    }


    formDidUpdate(formModel: ProductView, validationMap: any): void {
        this.setState({request: formModel, validationMap: validationMap});
    }

    renderContent(): JSX.Element {
        if (this.state.response) {
            return this.renderResults();
        }

        return this.renderForm();
    }

    renderResults(): JSX.Element {
        const response = this.state.response;
        const failedResults = response
            .results
            .filter(i => i.status !== "SUCCESS")
            .map(r => {return this.getPlayerRow(r)});

        const successResults = response
            .results
            .filter(i => i.status === "SUCCESS")
            .map(r => {return this.getPlayerRow(r)});


        const manualActions = (!response.removeItemSuccessful || !response.notificationSuccessful) && <h1>Manual Actions Needed</h1>;
        const notificationFailure = !response.notificationSuccessful && <div>Error when assigning notification, please assign manually to the users below.</div>;
        const deleteItemFailed = !response.removeItemSuccessful && <div>Error when trying to delete item, if all users were refunded please check & delete the item manually.</div>;


        return (
            <div>
                {manualActions}
                {notificationFailure}
                {deleteItemFailed}
                <h1>Failed {failedResults.length}/{response.results.length}</h1>
                <table width={"100%"}>
                    <tr><th>Player Id</th><th>Status</th></tr>
                    {failedResults}
                </table>

                <h1>Successful Refunds {successResults.length}/{response.results.length}</h1>
                <table width={"100%"}>
                    <tr><th>Player Id</th><th>Status</th></tr>
                    {successResults}
                </table>
            </div>
        );
    }

    getPlayerRow(result: RevokeResult): JSX.Element {
        return (
            <tr>
                <td>{result.playerId}</td>
                <td>{result.status}</td>
            </tr>
        );
    }

    renderForm(): JSX.Element {
        return (

            <div className="ibox-content" height="300px">

                <Form className="form-horizontal" formListener={this}
                      modelObject={this.state.request}
                      validationMap={this.state.validationMap}>


                    <div className="row">
                        <div className="col-lg-12">
                            <div className="float-e-margins">

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Notification</label>
                                    <div className="col-sm-10">
                                        <SelectInput className='form-control' model='notificationId'
                                                     optionModelValue={(n: LoginNotification) => n.id}
                                                     displayValue={(n: LoginNotification) => n.name}
                                                     values={this.state.activeNotifications}/>
                                    </div>
                                </FormGroup>

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <FormSubmitError/>
                            <div className="form-group">
                                <div className="col-sm-12">
                                    <DeleteButtonModal label='Revoke' className='btn-lg btn-danger'
                                                       onDelete={() => {
                                                           return this.onSubmit();
                                                       }}
                                                       description={this.props.params.id}/>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>
            </div>
        )
    }



}


// WEBPACK FOOTER //
// ./src/app/ui/view/item/ItemRefundView.tsx